import React from "react";
import styles from "./styles";
import {
  withStyles,
  CardContent,
  Collapse,
  Card,
  CardHeader,
  Avatar,
  IconButton,
} from "@material-ui/core";
import clsx from "clsx";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import StopChangeSequence from "../../../../mapComponents/Markers/Dispatch/StopChangeSequence";
import CollapsibleDetails from "./CollapsibleDetails";
import ProcessDeliveryDialog from "./EditStopDialog";
import ProcessPickupStopDialog from "./PickupProcessing";
import RemoveProDialog from "./RemovePro/index";
import Tooltip from "../../../../common/StyledToolTip";
import appConstants from "../../../../../appConstants";
import {
  formatAddress,
  getPendingStopStatus,
  getDeliveryStatusFromShipmentDelCode,
  sortStopsBySequence,
  isShipmentsHasExcessiveLength,
  getPickupStopStatus
} from "../../utils/utils";
import { SHOW_DRIVER_EVENTS, DRIVER_EVENTS } from "../constants";
import {
  isStopLocked,
  isStopLockedPermanently,
} from "./utils";
import { withSnackbar } from "notistack";
import { compose } from "recompose";
import { MoreVert } from "@material-ui/icons";
import StopActionMenu from "./StopActionMenu";
import constants from "./constants";
import { getStopArrivalTime } from "../utils/index"
import StopSequenceHistory from "./StopSequenceHistory";
import { ExcessiveLength } from "../../icons";
import ProNotes from "./ProNotes";
const lockedText =
  "Locked - Do not allow resequencing when new stops are added to the route";
const unLockedText =
  "Unlocked - Allow resequencing when new stops are added to the route";
class Cards extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: props.defaultExpanded,
      anchorEl: null,
      mutipleProData: [],
      action: null,
      showStopSequenceHistory: false,
      stopSequenceAnchorEl: null,
    };
  }

  handleExpandClick = () => {
    this.setState((prevState) => {
      return {
        expanded: !prevState.expanded,
      };
    });
  };

  handleMenuChange = (action) => {
    if (action === constants.STOPS_MENU_ACTION_LIST.MARK_AS_NEXT_STOP) {
      this.markAsNextStop();
    }
    this.setState({
      action,
      anchorEl: null,
    });
  };

  handleMenuClose = () => {
    this.setState({
      anchorEl: null,
    });
  };

  handleMenuOpen = (event) => {
    this.setState({
      anchorEl: event.currentTarget,
    });
  };

  handleClose = () => {
    this.setState({
      action: null,
    });
  };

  isPickupStop = () => {
    const { stopData } = this.props;
    return stopData.stopType === appConstants.STOP_TYPE.Pickup;
  };

  isStopCompleted = () => {
    const { stopData } = this.props;
    return stopData.isStopCompleted;
  };

  isCardMenuExpandable = () => {
    const {
      enableAddNotesToPro,
      enableAddProToCompletedPro,
      resequenceMode,
    } = this.props;
    if (enableAddNotesToPro || enableAddProToCompletedPro) {
      return !resequenceMode;
    }
    return !this.isStopCompleted() && !resequenceMode;
  };

  isNextStop = () => {
    const { stopData, routeData } = this.props;
    const { currentStatus } = routeData;
    const sortedStopList = sortStopsBySequence(routeData.stops);

    // check if route has arrived stop and current stop is next to it
    if (
      currentStatus?.stopId &&
      currentStatus?.status === DRIVER_EVENTS.ArrivedAtStop
    ) {
      const arrivedStop = sortedStopList.find(
        (stop) => stop.stopId === currentStatus.stopId
      );
      if(arrivedStop){
          return stopData.stopSequence === arrivedStop.stopSequence + 1;
      }
    }

    // check if current stop is first stop that is not completed yet
    const firstIncompleteStop = sortedStopList.find(
      (stop) => !stop.isStopCompleted
    );
    return firstIncompleteStop.stopId === stopData.stopId;
  };

  isDriverArrivedAtCurrentStop = () => {
    return this.props.isDriverCurrentStop && this.isDriverArrivedAtStop();
  };

  isMarkAsNextStopEnabled = () => {
    return (
      !this.isStopCompleted() &&
      !this.isNextStop() &&
      !this.isDriverArrivedAtCurrentStop()
    );
  };

  getUniqueShipmentDeliveryCodes = () => {
    const {
      stopData: { shipments },
    } = this.props;
    return [
      ...new Set(shipments.map((shipment) => shipment.returnCode)),
      ...new Set(shipments.map((shipment) => shipment.exceptionCode)),
    ].filter((data) => data);
  };

  populateSingleBillStopStatus = () => {
    const {
      stopData: { shipments },
    } = this.props;
    const deliveryStatus = getDeliveryStatusFromShipmentDelCode(
      shipments[0].deliveryCode
    );
    switch (deliveryStatus) {
      case appConstants.DELIVERY_STATUS.RETURN:
        return {
          overallStopStatus: deliveryStatus,
          stopStatusCode: shipments[0].returnCode,
          hasReturnOrExceptionBill: true,
        };
      case appConstants.DELIVERY_STATUS.DELIVERY_EXCEPTION:
        return {
          overallStopStatus: deliveryStatus,
          stopStatusCode: shipments[0].exceptionCode,
          hasReturnOrExceptionBill: true,
        };
      default:
        return {
          overallStopStatus: deliveryStatus,
          stopStatusCode: "",
          hasReturnOrExceptionBill: false,
        };
    }
  };

  populateMultipleBillStopStatus = () => {
    const multipleBillsStatusCodes = this.getUniqueShipmentDeliveryCodes();
    const combinedStopStatusCodes =
      multipleBillsStatusCodes.length > 0
        ? multipleBillsStatusCodes.join(",")
        : "";
    const hasReturnOrException = multipleBillsStatusCodes.length > 0;
    return {
      overallStopStatus: "Completed",
      stopStatusCode: combinedStopStatusCodes,
      hasReturnOrExceptionBill: hasReturnOrException,
    };
  };

  populatePickupStopStatus = () => {
    const { stopData } = this.props;
    return {
      overallStopStatus: getPickupStopStatus(stopData),
      stopStatusCode: "",
      hasReturnOrExceptionBill: false,
    };
  };

  getStopStatus = () => {
    const {
      stopData,
      stopData: { numberOfBills },
    } = this.props;
    if (!this.isStopCompleted()) {
      return getPendingStopStatus(stopData);
    }
    if (this.isPickupStop()) {
      return this.populatePickupStopStatus();
    }
    if (numberOfBills < 2) {
      return this.populateSingleBillStopStatus();
    }
    return this.populateMultipleBillStopStatus();
  };

  getPendingStopClasses = (pendingStopStatus) => {
    if (pendingStopStatus === appConstants.STOP_STATUS.DELAYED) {
      return this.getPendingStopWithDelayClasses();
    }
    return this.getPendingStopWithoutDelayClasses();
  };

  getStopWithReturnOrExceptionClasses = () => {
    const { classes } = this.props;
    return {
      title: classes.titleReturnOrException,
      subheader: classes.subheaderReturnOrException,
      avatar: classes.avatarReturnOrException,
      avatarColor: this.props.theme.ErrorMessageColor,
      statusWrapper: classes.statusWrapperReturnOrException,
      stopStatus: classes.stopStatusReturnOrException,
      priority: classes.priorityReturnOrException,
      statusTime: classes.statusTimeReturnOrException,
    };
  };

  getCompletedStopClasses = () => {
    const { classes } = this.props;
    return {
      title: classes.titleCompleted,
      subheader: classes.subheaderCompleted,
      avatar: classes.avatarCompleted,
      avatarColor: this.props.theme.completeStopText,
      statusWrapper: classes.statusWrapperCompleted,
      stopStatus: classes.stopStatusCompleted,
      priority: classes.priorityCompleted,
      statusTime: classes.statusTimeCompleted,
    };
  };

  getPendingStopWithoutDelayClasses = () => {
    const { classes } = this.props;
    return {
      title: classes.titlePending,
      subheader: classes.subheaderPending,
      avatar: classes.avatarPending,
      avatarColor: this.props.theme.ToggleIconColor,
      statusWrapper: classes.statusWrapperPending,
      stopStatus: classes.stopStatusPending,
      priority: classes.priorityPending,
      statusTime: classes.statusTimePending,
    };
  };

  getPendingStopWithDelayClasses = () => {
    return this.getStopWithReturnOrExceptionClasses();
  };

  getCompletedStopCustomClasses = (stopStatusObject) => {
    if (stopStatusObject.hasReturnOrExceptionBill) {
      return this.getStopWithReturnOrExceptionClasses();
    } else {
      return this.getCompletedStopClasses();
    }
  };

  isDriverArrivedAtStop = () => {
    const { routeData } = this.props;
    return routeData?.driverStatus === DRIVER_EVENTS.ArrivedAtStop;
  };

  isDriverDelayedAtArrivedStop = () => {
    const { stopData } = this.props;
    if (this.isDriverArrivedAtStop()) {
      return (
        getPendingStopStatus(stopData, stopData?.actualArrivalTime) ===
        appConstants.STOP_STATUS.DELAYED
      );
    }
    return false;
  };

  getPendingStopArrivalTime = (stopStatusObject, stopData) => {
    return stopStatusObject === appConstants.STOP_STATUS.DELAYED
      ? `${stopData.plannedArrivalTime} (${appConstants.STOP_STATUS.DELAYED})`
      : stopData.plannedArrivalTime;
  };

  getCompletedStopArrivalTime = (stopData) => {
    return `${stopData.actualArrivalTime ?? ""} - ${
      stopData.actualDepartureTime ?? ""
    }`;
  };

  getCurrentStopTime = (stopData) => {
    const arrivalTime = getStopArrivalTime(
      this.props.routeData?.currentStatus.status,
      stopData
    );
    return `${arrivalTime} ${
      this.isDriverDelayedAtArrivedStop()
        ? `(${appConstants.STOP_STATUS.DELAYED})`
        : ""
    }`;
  }

  renderArrivalTime = (stopStatusObject) => {
    const { stopData, isDriverCurrentStop } = this.props;
    if (!isDriverCurrentStop) {
      return this.isStopCompleted()
        ? this.getCompletedStopArrivalTime(stopData)
        : this.getPendingStopArrivalTime(stopStatusObject, stopData);
    }
    return this.getCurrentStopTime(stopData);
  };

  getDriverStatusDetails = () => {
    const { routeData } = this.props;
    return {
      stopStatusObject: null,
      customClasses: this.isDriverDelayedAtArrivedStop()
        ? this.getPendingStopWithDelayClasses()
        : this.getPendingStopWithoutDelayClasses(),
      overallStopStatus: `${
        SHOW_DRIVER_EVENTS[routeData?.currentStatus.status]
      } Stop`,
      stopStatusCode: "",
    };
  };

  getStopStatusDetails = () => {
    const stopStatus = this.getStopStatus();
    return {
      stopStatusObject: stopStatus,
      customClasses: this.isStopCompleted()
        ? this.getCompletedStopCustomClasses(stopStatus)
        : this.getPendingStopClasses(stopStatus),
      overallStopStatus: this.isStopCompleted()
        ? stopStatus?.overallStopStatus ?? ""
        : "ETA",
      stopStatusCode: stopStatus?.stopStatusCode ?? "",
    };
  };

  getStopProps = () => {
    const { isDriverCurrentStop } = this.props;
    if (!isDriverCurrentStop) {
      return this.getStopStatusDetails();
    }
    return this.getDriverStatusDetails();
  };

  onLockChange = () => {
    const { stopSequence, isLocked, isStopCompleted } = this.props.stopData;

    const stopCompleted = isLocked || isStopCompleted;
    this.props.onLockChanged(stopSequence, !stopCompleted);
  };

  markAsNextStop = () => {
    this.handleMenuClose();
    this.props.updateNextStop?.(this.props.stopData);
  };

  renderCardActions = () => {
    const { stopData, stopData: {isStopCompleted} } = this.props;
    const isLocked = isStopLocked(
      stopData,
      this.props.routeData.currentStatus
    );
    const isCardMenuExpandable = this.isCardMenuExpandable();
    const isMarkAsNextStopEnabled = this.isMarkAsNextStopEnabled();
    const { classes, resequenceMode, enableDispatchRouteResequence } =
      this.props;
    const lockIconTooltip = isLocked ? lockedText : unLockedText;
    const lockIcon = isLocked ? (
      <i className={appConstants.routeLockStates.LOCK.icon} />
    ) : (
      <i className={appConstants.routeLockStates.PARTIAL_LOCK.icon} />
    );
    return (
      <div>
        {enableDispatchRouteResequence ? (
          <IconButton
            aria-label="Lock"
            classes={{ root: classes.lockIcon, disabled: classes.disableIcon }}
            onClick={this.onLockChange}
            disabled={
              !resequenceMode ||
              isStopLockedPermanently(
                stopData,
                this.props.routeData.currentStatus
              )
            }
          >
            <Tooltip title={lockIconTooltip} placement="bottom-start">
              {lockIcon}
            </Tooltip>
          </IconButton>
        ) : null}
        <IconButton
          aria-label="edit"
          disabled={!isCardMenuExpandable}
          className={`${classes.editIcon} ${
            isCardMenuExpandable ? classes.enableIcon : classes.disableIcon
          }`}
          onClick={this.handleMenuOpen}
        >
          <Tooltip
            title={
              isStopCompleted
                ? "Stop already completed"
                : "Select stop to update"
            }
          >
            <MoreVert />
          </Tooltip>
        </IconButton>
        <StopActionMenu
          handleMenuClose={this.handleMenuClose}
          anchorEl={this.state.anchorEl}
          handleMenuChange={this.handleMenuChange}
          isPickupStop={this.isPickupStop()}
          isMarkAsNextStopEnabled={isMarkAsNextStopEnabled}
          enableRemovePro={this.props.enableRemovePro}
          enableAddNotesToPro={this.props.enableAddNotesToPro}
          enableAddProToCompletedPro={this.props.enableAddProToCompletedPro}
          isCompletedStop={this.isStopCompleted()}
          isNoFreight={stopData.isNoFreight}
        />
      </div>
    );
  };

  toggleStopSequenceModel = (event) => {
    event.persist();
    this.setState({
      stopSequenceAnchorEl: this.state.stopSequenceAnchorEl
        ? null
        : event.currentTarget,
    });
  };

  render() {
    const { classes, stopData, routeData, terminalCode, theme } = this.props;
    const isDriverArrived =  this.isDriverArrivedAtCurrentStop()
    const priority = stopData.priority?.join(",") || "";
    const {
      stopStatusObject,
      customClasses,
      overallStopStatus,
      stopStatusCode,
    } = this.getStopProps();
    const { action, stopSequenceAnchorEl } = this.state;
    const isPickupStop = this.isPickupStop();
    const stopHasExcessiveLength = isShipmentsHasExcessiveLength(stopData.shipments, stopData.stopType);
    const stopAddress = formatAddress({
      address: stopData?.address,
      address2: stopData?.address2,
      city: stopData?.city,
      state: stopData?.state,
      zip: stopData?.zip,
    })
    const stopTime= stopData.arrivalTime ? this.renderArrivalTime(stopStatusObject): "";
    return (
      <Card className={classes.card}>
        <CardHeader
          classes={{
            title: customClasses.title,
            subheader: customClasses.subheader,
            root: classes.headerRoot,
          }}
          avatar={
            <Avatar
              aria-label="stopNo"
              className={`${customClasses.avatar} ${
                isPickupStop ? classes.pickupStopAvatar : ""
              }`}
            >
              {`${stopData.stopSequence}${isPickupStop ? "P" : "D"}`}
            </Avatar>
          }
          action={this.renderCardActions()}
          title={stopData.name}
          subheader={
            <>
              {stopAddress}
              {stopHasExcessiveLength && (
                <Tooltip key="excessiveLength" title="Excessive Length">
                  <div className={classes.excessiveLength}>
                    <ExcessiveLength
                      color = {theme.iconColor}
                    />
                  </div>
                </Tooltip>
              )}
            </>
          }
        />
        <CardContent className={classes.noPadding}>
          <div className={customClasses.statusWrapper}>
            <div className={classes.status}>
              <div className={classes.statusContainer}>
                {stopData.isDriverChangedSequence && (
                  <Tooltip title="Driver updated the stop sequence">
                    <div className={classes.stopSequenceIcon}>
                      <IconButton
                        aria-label="stop-sequence-icon"
                        onClick={this.toggleStopSequenceModel}
                      >
                        <StopChangeSequence color={customClasses.avatarColor} />
                      </IconButton>
                    </div>
                  </Tooltip>
                )}
                <div id="status" className={customClasses.stopStatus}>
                  {overallStopStatus}
                </div>
              </div>

              <div className={classes.statusCodeContainer}>
                {stopStatusCode && (
                  <Tooltip title={stopStatusCode}>
                    <div className={classes.statusCode}>
                      <span
                        id="delStatusCode"
                        className={customClasses.priority}
                      >
                        {stopStatusCode}
                      </span>
                    </div>
                  </Tooltip>
                )}
                {priority && (
                  <div
                    className={
                      stopData.arrivalTime ? classes.priorityContainer : null
                    }
                  >
                    <span id="priority" className={customClasses.priority}>
                      {priority}
                    </span>
                  </div>
                )}
                {stopData.arrivalTime && (
                  <div className={classes.arrivalTime}>
                    <span id="statusTime" className={customClasses.statusTime}>
                      {stopTime}
                    </span>
                  </div>
                )}
              </div>
              {!this.props.resequenceMode ? (
                <IconButton
                  className={clsx(classes.expand, {
                    [classes.expandOpen]: this.state.expanded,
                  })}
                  onClick={this.handleExpandClick}
                  aria-expanded={this.state.expanded}
                  aria-label="show more"
                >
                  <ExpandMoreIcon />
                </IconButton>
              ) : null}
            </div>
          </div>
        </CardContent>
        <Collapse
          in={!this.props.resequenceMode && this.state.expanded}
          timeout="auto"
          unmountOnExit
        >
          <CardContent
            classes={{
              root: classes.collapsibleDetailsRoot,
            }}
          >
            <CollapsibleDetails
              data={stopData}
              viewStopImages={this.props.viewStopImages}
            />
          </CardContent>
        </Collapse>
        {action === constants.STOPS_MENU_ACTION_LIST.PROCESS_DELIVERY && (
          <ProcessDeliveryDialog
            open={true}
            isDriverArrived={isDriverArrived}
            handleClose={this.handleClose}
            stopData={stopData}
            routeData={routeData}
            glEventHub={this.props.glEventHub}
          />
        )}
        {action === constants.STOPS_MENU_ACTION_LIST.PROCESS_PICKUP && (
          <ProcessPickupStopDialog
            open={true}
            isDriverArrived={isDriverArrived}
            handleClose={this.handleClose}
            stopData={stopData}
            routeData={routeData}
            glEventHub={this.props.glEventHub}
          />
        )}
        {action === constants.STOPS_MENU_ACTION_LIST.ADD_PRO_TO_PICKUP && (
          <ProcessPickupStopDialog
            open
            isDriverArrived={isDriverArrived}
            handleClose={this.handleClose}
            stopData={stopData}
            routeData={routeData}
            glEventHub={this.props.glEventHub}
            isReadOnly
            isAddProToCompletedPickupFlow
          />
        )}
        {action === constants.STOPS_MENU_ACTION_LIST.REMOVE_PRO && (
          <RemoveProDialog
            open={true}
            handleClose={this.handleClose}
            stopData={stopData}
            routeData={routeData}
          />
        )}
        {stopSequenceAnchorEl && (
          <StopSequenceHistory
            terminalCode={terminalCode}
            routeId={routeData.routeId}
            stopId={stopData.stopId}
            closeModel={this.toggleStopSequenceModel}
            stopSequenceAnchorEl={stopSequenceAnchorEl}
          />
        )}
        {action === constants.STOPS_MENU_ACTION_LIST.ADD_PRO_NOTES && (
          <ProNotes
            open
            title="Add Notes to Pro"
            handleClose={this.handleClose}
            stopDetails={{
              shipments: stopData.shipments,
              stopName: stopData.name,
              stopStatus: overallStopStatus,
              stopAddress,
              isPickupStop,
              stopTime
            }}
            terminalCode={terminalCode}
            driverId={this.props.driverId}
          />
        )}
      </Card>
    );
  }
}

export default compose(withStyles(styles), withSnackbar)(Cards);
